export const getBreadcrumbStructuredData = ({
  canonical,
  breadcrumbs = [],
  title,
  brandName,
  brandLinkUrl
} = {}) => {

  if (breadcrumbs && breadcrumbs.length && breadcrumbs?.[0]?.label !== 'Home') {
    breadcrumbs.unshift({ label: 'Home', url: '' });
  }

  const finalBreadcrumbs = [...breadcrumbs];

  // Add branded breadcrumb if brand info is available
  if (brandName && brandLinkUrl) {
    const lastCrumb = breadcrumbs[breadcrumbs.length - 1];

    finalBreadcrumbs.push({
      label: `${brandName} ${lastCrumb?.label || ''}`.trim(),
      url: brandLinkUrl
    });
  }

  return {
    '@type': 'WebPage',
    name: title,
    url: canonical,
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: (finalBreadcrumbs || []).map(({ label, url }, i) => ({
        '@type': 'ListItem',
        position: i + 1,
        item: {
          '@type': 'Thing',
          name: label,
          '@id': `https://www.homedepot.com${url}`,
        },
      })),
    },
    '@context': 'http://schema.org',
  };
};
